<template>
  <div class="customer-transfers-view">
    <div class="customer-transfers-header">
      <h3>{{ $t('dos.title') }}</h3>
      <el-button
          type="primary"
          size="small"
          icon="el-icon-refresh"
          @click="refresh">
        {{ $t('dos.refresh') }}
      </el-button>
    </div>
    <filter-panel
        @filter-applied="onFilterApplied"
        @filter-cleared="onFilterCleared" />
    <div v-loading="loading">
      <el-table
          :data="transferRequests"
          style="width: 100%">
        <el-table-column
            :label="$t('dos.customer_transfers.columns.actions')">
          <template slot-scope="scope">
            <router-link :to="{ name: 'DeviceTransfers', params: { transfer_id: scope.row.transfer_request_id } }">
              {{ $t('dos.customer_transfers.columns.actions') }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
            :label="$t('dos.customer_transfers.columns.doorbot_id')"
            prop="transfer_request_id" />
        <el-table-column
            :label="$t('dos.customer_transfers.columns.mac_address')"
            prop="mac_address" />
        <el-table-column
            :label="$t('dos.customer_transfers.columns.product')"
            prop="transfer_type" />
        <el-table-column
            :label="$t('dos.customer_transfers.columns.old_owner')"
            prop="old_owner_id" />
        <el-table-column
            :label="$t('dos.customer_transfers.columns.new_owner')"
            prop="new_owner_id" />
        <el-table-column
            :label="$t('dos.customer_transfers.columns.status')"
            prop="status" />
        <el-table-column
            :label="$t('dos.customer_transfers.columns.reason')"
            prop="transfer_request_type" />
        <el-table-column
            :label="$t('dos.customer_transfers.columns.start_date')">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column
            :label="$t('dos.customer_transfers.columns.end_date')">
          <template slot-scope="scope">
            {{ formatDate(scope.row.auto_approve_date) }}
          </template>
        </el-table-column>
        <template slot="empty">
          <span v-if="isFiltered">{{ $t('dos.customer_transfers.no_filter_results') }}</span>
          <span v-else>{{ $t('dos.customer_transfers.empty') }}</span>
        </template>
      </el-table>
    </div>
    <router-view />
  </div>
</template>

<script>
import moment from "moment-timezone";
import { createNamespacedHelpers as namespace } from "vuex";
import FilterPanel from "./FilterPanel.vue";

const { mapGetters: dosGetters, mapActions: dosActions } = namespace("db/dos");
const { mapGetters: accountGetters } = namespace("db/account");

export default {
  name: "CustomerTransfersView",
  components: {
    FilterPanel,
  },
  data() {
    return {
      isFiltered: false,
    };
  },
  computed: {
    ...dosGetters(["transferRequests", "loading", "error"]),
    ...accountGetters(["customerId"]),
  },
  watch: {
    error(newError) {
      if (newError && !this.isFiltered) {
        this.$notify.error({
          title: this.$t("dos.customer_transfers.error"),
          message: newError.message || this.$t("dos.customer_transfers.error"),
          duration: 0,
        });
      }
    },
  },
  created() {
    this.fetchTransfers();
  },
  methods: {
    ...dosActions(["fetchTransferRequests"]),
    formatDate(date) {
      if (!date) return "";
      return moment(date).format("MM/DD/YYYY HH:mm Z");
    },
    fetchTransfers(filters) {
      this.fetchTransferRequests({
        userId: this.customerId,
        filters,
      });
    },
    refresh() {
      this.isFiltered = false;
      this.fetchTransfers();
    },
    onFilterApplied(filters) {
      this.isFiltered = true;
      this.fetchTransferRequests({
        userId: this.customerId,
        filters,
      }).catch(() => {
        this.$notify.error({
          title: this.$t("dos.customer_transfers.error"),
          message: this.$t("dos.customer_transfers.error"),
          duration: 0,
        });
      });
    },
    onFilterCleared() {
      this.isFiltered = false;
      this.fetchTransfers();
    },
  },
};
</script>

<style scoped>
.customer-transfers-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
</style>
